import React from 'react';
import NftWalletWrapper from '../components/NftWallet';

const NftWallet = () => {
  return <NftWalletWrapper />;
};

export default NftWallet;
